import QbuddyService from './services';

export const actions = {
  async getProviderGames({ commit }) {
    commit('GET_PROVIDER_GAMES');
    try {
      const providerGames = await QbuddyService.getProviderGames();
      commit('GET_PROVIDER_GAMES_SUCCESS', providerGames);
    } catch (error) {
      commit('GET_PROVIDER_GAMES_FAILURE', { error });
      throw error;
    }
  },
  setProviderGames({ commit }, providerGames) {
    commit('GET_PROVIDER_GAMES');
    try {
      commit('GET_PROVIDER_GAMES_SUCCESS', providerGames);
    } catch (error) {
      commit('GET_PROVIDER_GAMES_FAILURE', { error });
      throw error;
    }
  },
  async getAllowedGames({ commit }) {
    commit('GET_ALLOWED_GAMES');
    try {
      const providerGames = await QbuddyService.getListAllowedGames();
      commit('GET_ALLOWED_GAMES_SUCCESS', providerGames);
    } catch (error) {
      commit('GET_ALLOWED_GAMES_FAILURE', { error });
      throw error;
    }
  },
  setAllowedGames({ commit }, allowedGames) {
    commit('GET_ALLOWED_GAMES');
    try {
      commit('GET_ALLOWED_GAMES_SUCCESS', allowedGames);
    } catch (error) {
      commit('GET_ALLOWED_GAMES_FAILURE', { error });
      throw error;
    }
  },
  async getProviderInfoForEdit({ commit }) {
    commit('GET_PROVIDER_INFO_FOR_EDIT');
    try {
      const provider = await QbuddyService.getProviderInfoForEdit();
      commit('GET_PROVIDER_INFO_FOR_EDIT_SUCCESS', provider);
    } catch (error) {
      commit('GET_PROVIDER_INFO_FOR_EDIT_FAILURE', { error });
      throw error;
    }
  },
  async updatePublicProfile({ commit }, { profile }) {
    commit('UPDATE_PUBLIC_PROFILE');
    try {
      const response = await QbuddyService.updatePublicProfile(profile);
      commit('UPDATE_PUBLIC_PROFILE_SUCCESS', response);
    } catch (error) {
      commit('UPDATE_PUBLIC_PROFILE_FAILURE', { error });
      throw error;
    }
  },
  async updateAvailability({ commit }, { availability, conflictingOrdersAction }) {
    commit('UPDATE_AVAILABILITY');
    try {
      const response = await QbuddyService.updateAvailability(availability, conflictingOrdersAction);
      commit('UPDATE_AVAILABILITY_SUCCESS', response);
    } catch (error) {
      commit('UPDATE_AVAILABILITY_FAILURE', { error });
      throw error;
    }
  },
  async addOrUpdateService({ commit }, { service }) {
    commit('ADD_OR_UPDATE_SERVICE');
    try {
      const response = await QbuddyService.addOrUpdateService(service);
      commit('ADD_OR_UPDATE_SERVICE_SUCCESS', response);
    } catch (error) {
      commit('ADD_OR_UPDATE_SERVICE_FAILURE', { error });
      throw error;
    }
  },
  async removeService({ commit }, { service, conflictingOrdersAction }) {
    commit('REMOVE_SERVICE');
    try {
      const response = await QbuddyService.removeService(service, conflictingOrdersAction);
      commit('REMOVE_SERVICE_SUCCESS', response);
    } catch (error) {
      commit('REMOVE_SERVICE_FAILURE', { error });
      throw error;
    }
  },
  async addOrUpdateGame({ commit }, { game }) {
    commit('ADD_OR_UPDATE_GAME');
    try {
      const response = await QbuddyService.addOrUpdateGame(game);
      commit('ADD_OR_UPDATE_GAME_SUCCESS', response);
    } catch (error) {
      commit('ADD_OR_UPDATE_GAME_FAILURE', { error });
      throw error;
    }
  },
  async removeGame({ commit }, { game, conflictingOrdersAction }) {
    commit('REMOVE_GAME');
    try {
      const response = await QbuddyService.removeGame(game, conflictingOrdersAction);
      commit('REMOVE_GAME_SUCCESS', response);
    } catch (error) {
      commit('REMOVE_GAME_FAILURE', { error });
      throw error;
    }
  },
  async addOrUpdateAnnouncement({ commit }, { announcement }) {
    commit('ADD_OR_UPDATE_ANNOUNCEMENT');
    try {
      const response = await QbuddyService.addOrUpdateAnnouncement(announcement);
      commit('ADD_OR_UPDATE_ANNOUNCEMENT_SUCCESS', response);
    } catch (error) {
      commit('ADD_OR_UPDATE_ANNOUNCEMENT_FAILURE', { error });
      throw error;
    }
  },
  async removeAnnouncement({ commit }, { announcement }) {
    commit('REMOVE_ANNOUNCEMENT');
    try {
      const response = await QbuddyService.removeAnnouncement(announcement);
      commit('REMOVE_ANNOUNCEMENT_SUCCESS', response);
    } catch (error) {
      commit('REMOVE_ANNOUNCEMENT_FAILURE', { error });
      throw error;
    }
  },
  async getIncomingOrders({ commit }) {
    commit('GET_INCOMING_ORDERS');
    try {
      const incomingOrders = await QbuddyService.getIncomingOrders();
      commit('GET_INCOMING_ORDERS_SUCCESS', incomingOrders);
    } catch (error) {
      commit('GET_INCOMING_ORDERS_FAILURE', { error });
      throw error;
    }
  },
  setIncomingOrders({ commit }, incomingOrders) {
    commit('GET_INCOMING_ORDERS');
    try {
      commit('GET_INCOMING_ORDERS_SUCCESS', incomingOrders);
    } catch (error) {
      commit('GET_INCOMING_ORDERS_FAILURE', { error });
      throw error;
    }
  },
  async getMyLobbySessions({ commit }, { isProvider }) {
    commit('GET_LOBBY_SESSIONS');
    try {
      const lobbySessions = await QbuddyService.getMyLobbySessions(isProvider);
      if (isProvider){
        commit('GET_PROVIDER_LOBBY_SESSIONS_SUCCESS', lobbySessions);
      } else {
        commit('GET_CONSUMER_LOBBY_SESSION_SUCCESS', lobbySessions);
      }
    } catch (error) {
      commit('GET_LOBBY_SESSIONS_FAILURE', { error });
      throw error;
    }
  },
  setConsumerLobbySessions({ commit }, sessions) {
    commit('GET_LOBBY_SESSIONS');
    try {
      commit('GET_CONSUMER_LOBBY_SESSION_SUCCESS', sessions);
    } catch (error) {
      commit('GET_LOBBY_SESSIONS_FAILURE', { error });
      throw error;
    }
  },
  async getOldLobbySession({ commit }, { isProvider, page, limit }) {
    commit('GET_LOBBY_SESSIONS');
    try {
      const lobbySessions = await QbuddyService.getOldLobbySessions(isProvider, page, limit);
      if (isProvider){
        commit('UPDATE_PROVIDER_LOBBY_SESSION', lobbySessions);
      } else {
        commit('UPDATE_CONSUMER_LOBBY_SESSION', lobbySessions);
      }
    } catch (error) {
      commit('GET_LOBBY_SESSIONS_FAILURE', { error });
      throw error;
    }
  },
  updateEdittingLobbySession({ commit }, { data }) {
    commit('UPDATE_EDITTING_LOBBY_SESSION', data);
  },
};
